export { LoginComponent } from './login/login.component';
export { OTPComponent } from './otp/otp.component';
export { ForgotComponent } from './forgot/forgot.component';
